import React from 'react';
import {Avatar, Box, SxProps, styled, Typography} from '@mui/material';
import PersonIcon from '@mui/icons-material/Person';
import {useTranslation} from 'react-i18next';
import PlayerNumber from './PlayerNumber';

const ProfileIdentityWrapper = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  maxWidth: '100%',
}));

const ProfilePictureImage = styled(Avatar)(
  (props: {size?: 'default' | 'small'}) => ({
    height: props.size === 'small' ? '40px' : '60px',
    width: props.size === 'small' ? '40px' : '60px',
    marginRight: '10px',
    background: 'transparent',
    border: 'solid 1px #fff',
  }),
);

interface Props {
  firstName?: string;
  lastName?: string;
  position?: string;
  expandNumberIfEmpty?: boolean;
  number?: number;
  profilePictureUrl?: string;
  size?: 'default' | 'small';
  sx?: SxProps;
}

const ProfileIdentity: React.FC<Props> = ({
  firstName,
  lastName,
  position,
  expandNumberIfEmpty,
  number,
  profilePictureUrl,
  size,
  sx,
}) => {
  const {t} = useTranslation();

  return (
    <ProfileIdentityWrapper sx={sx}>
      {(number || expandNumberIfEmpty) && (
        <PlayerNumber
          number={number}
          expandIfEmpty={expandNumberIfEmpty}
          size={size}
        />
      )}
      {profilePictureUrl ? (
        <ProfilePictureImage
          size={size}
          src={profilePictureUrl}
          alt={`${firstName} ${lastName}`}
        />
      ) : (
        <ProfilePictureImage size={size}>
          <PersonIcon
            color="info"
            sx={{fontSize: size === 'small' ? '24px' : '40px'}}
          />
        </ProfilePictureImage>
      )}
      <Box sx={{overflow: 'hidden'}}>
        <Typography
          variant="h4"
          overflow="hidden"
          textOverflow="ellipsis"
          whiteSpace="nowrap">
          <em>{`${firstName} ${lastName}`}</em>
        </Typography>
        {position && (
          <Typography
            variant="body1"
            overflow="hidden"
            textOverflow="ellipsis"
            whiteSpace="nowrap">
            {t(`position.${position}`)}
          </Typography>
        )}
      </Box>
    </ProfileIdentityWrapper>
  );
};

export default ProfileIdentity;
